import api from "../api";
import axios from "axios";
import moment from "moment-timezone";

export default class CommonService {
    async getMasterItemList(masterKey, masterNameText, userId, companyId) {
        return await api.get(
            `Common/GetMasterItemList/${masterKey}/${masterNameText}/${userId}/${companyId}`
        );
    }
    async getStatesList(countryId) {
        return await api.get(`Common/getStatesList/${countryId}`);
    }
    async getModuleList(userId, companyId) {
        return await api.get(`Common/GetModuleList/${userId}/${companyId}`);
    }
    async getSubModuleList(moduleId, userId, companyId) {
        return await api.get(
            `Common/GetSubModuleList/${moduleId}/${userId}/${companyId}`
        );
    }
    async getLoanAppModuleList(userId, companyId) {
        debugger;
        return await api.get(`Common/GetLoanAppModuleList/${userId}/${companyId}`);
    }
    async getLoanAppSubModuleList(moduleId, userId, companyId) {
        return await api.get(
            `Common/GetLoanAppSubModuleList/${moduleId}/${userId}/${companyId}`
        );
    }
    async getCustomFieldsData(
        primaryKey,
        moduleCode,
        subModuleCode,
        otherData,
        refId,
        displayCode,
        companyId,
        userId,
        isFor,
        deviceType,
        layoutType
    ) {
        return await api.get(`Common/GetCustomFieldsData/${primaryKey}/${moduleCode}/${subModuleCode}/${otherData}/${refId}/${displayCode}/${companyId}/${userId}/${isFor}
            /${deviceType}/${layoutType}`);
    }

    async GetPageSizeList() {
        let masterNames = "PageSize";
        let masterKeyText = "PageSize";
        let userId = localStorage.getItem("userId");
        return await api.get(
            `userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`
        );
    }

    async getCustomFieldsDataDemoJson(
        primaryKey,
        moduleCode,
        subModuleCode,
        otherData,
        refId,
        displayCode,
        companyId,
        userId,
        isFor,
        deviceType,
        layoutType
    ) {
        return await axios.get("../FormCustomFields.json");
    }

    async CheckDuplicateCrm(object) {
        return await api.post(`Common/CheckDuplicateCrm`, object);
        //return await api.get(`Common/CheckDuplicateCrm/${Id}/${PrimaryId}/${name}/${subModule}/${type}/${companyId}/${userId}`);
    }

    async GetDropdownValues(
        id,
        refId,
        keyword,
        companyId,
        userId,
        length,
        searchText
    ) {
        return await api.get(
            `Common/GetDropdownValues/${id}/${refId}/${keyword}/${companyId}/${userId}/${length}/${searchText}`
        );
    }
    async getManageViewList(
        nameSearch,
        sortColumn,
        sortDir,
        pageNumber,
        pageSize,
        companyId,
        userId,
        moduleCode,
        subModuleCode
    ) {
        return await api.get(
            `Common/GetManageViewList/${nameSearch}/${sortColumn}/${sortDir}/${pageNumber}/${pageSize}/${companyId}/${userId}/${moduleCode}/${subModuleCode}`
        );
    }

    async GetCustomFieldsDropDownList(
        length,
        customFieldId,
        fieldCode,
        serchText,
        primaryKey,
        companyId,
        userId
    ) {
        return await api.get(
            `Common/GetCustomFieldsDropDownList/${length}/${customFieldId}/${fieldCode}/${serchText}/${primaryKey}/${companyId}/${userId}`
        );
    }
    async getManageViewCustomFieldsList(
        companyId,
        userId,
        moduleCode,
        subModuleCode,
        controlName,
        sortable,
        fieldlistFilter,
        isfor,
        refId,
        displayCode
    ) {
        return await api.get(
            `Common/GetManageViewCustomFieldsList/${companyId}/${userId}/${moduleCode}/${subModuleCode}/${controlName}/${sortable}/${fieldlistFilter}/${isfor}/${refId}/${displayCode}`
        );
    }

    async GetMasterItemsNotAuth(masterNames, UserId, masterKeyText) {
        return await api.get(
            `Common/GetMasterItemsNotAuth/${masterNames}/${UserId}/${masterKeyText}`
        );
    }

    async getStageDetailsById(userid, companyId, id, moduleCode, submoduleCode) {
        //return await axios.get('../../StagesData.json');
        return await api.get(
            `Common/GetStageDetailsById/${userid}/${companyId}/${id}/${moduleCode}/${submoduleCode}`
        );
    }

    async GetSolCustomFieldsList(companyId, userId, loanAppStageId, PrimaryId) {
        //return await axios.get('../.. / StageCustomFields.json ');
        return await api.get(
            `Common/GetSolCustomFieldsList/${companyId}/${userId}/${loanAppStageId}/${PrimaryId}`
        );
    }

    async addEditSolgenStageForm(stageData) {
        return await api.post(`Common/AddEditStageForm`, stageData);
    }

    async markAsCompleteStatus(markData) {
        return await api.post(`Common/MarkAsCompleteStatus`, markData);
    }

    async GetAllStages(companyId, userId, batchId, moduleId, subModuleId) {
        return await api.get(
            `Common/GetAllStages/${companyId}/${userId}/${batchId}/${moduleId}/${subModuleId}`
        );
    }

    async getManageViewCustomFieldsListManage(
        companyId,
        userId,
        moduleCode,
        subModuleCode,
        Id,
        strType,
        search,
        isFor,
        isRef,
        PrimaryId,
        refId,
        displayCod
    ) {
        return await api.get(
            `Common/GetManageViewCustomFieldsListManage/${companyId}/${userId}/${moduleCode}/${subModuleCode}/${Id}/${strType}/${search}/${isFor}/${isRef}/${PrimaryId}/${refId}/${displayCod}`
        );
    }

    async getOperatorsItems(companyId, userId, customFieldId) {
        return await api.get(
            `Common/GetOperatorsItems/${companyId}/${userId}/${customFieldId}`
        );
    }

    async addEditManageView(dataModel) {
        return await api.post(`Common/AddEditManageView`, dataModel);
    }

    async getCustomViewbyId(companyId, userId, customViewId) {
        return await api.get(
            `Common/GetCustomViewbyId/${companyId}/${userId}/${customViewId}`
        );
    }

    async deleteRecord(obj) {
        return await api.post(`Common/DeleteCustomView`, obj);
    }

    async saveCustomDefaultView(
        companyId,
        userId,
        moduleCode,
        subModuleCode,
        customViewId
    ) {
        return await api.get(
            `Common/SaveCustomDefaultView/${companyId}/${userId}/${moduleCode}/${subModuleCode}/${customViewId}`
        );
    }

    async getStageFormDetail(formId, companyId, userId) {
        return await api.get(
            `Common/GetStageFormDetail/${formId}/${companyId}/${userId}`
        );
    }

    async AddStageForm(model) {
        return await api.post(`Common/AddStageForm`, model);
    }

    async getCustomViewForListingDropdown(
        companyId,
        userId,
        moduleCode,
        subModuleCode
    ) {
        return await api.get(
            `Common/GetCustomViewForListingDropdown/${companyId}/${userId}/${moduleCode}/${subModuleCode}`
        );
    }

    async GetEmailSettings(companyId, userId) {
        return await api.get(`Common/GetEmailSettings/${companyId}/${userId}`);
    }
    TryJsonParse(json) {
        try {
            let _json = JSON.parse(json);
            return _json;
        } catch {
            return json;
        }
    }

    async GetRelatedObjects(
        moduleCode,
        subModuleCode,
        primaryId,
        deviceType,
        layoutType,
        CompanyId,
        userId
    ) {
        return await api.get(
            `Common/GetRelatedObjects/${moduleCode}/${subModuleCode}/${primaryId}/${deviceType}/${layoutType}/${CompanyId}/${userId}`
        );
    }

    async GetRelatedObjectsCompactView(
        compact_view_id,
        sub_module_code,
        record_id,
        sortColumn,
        sortDirection,
        pageNo,
        pageSize,
        companyId
    ) {
        return await api.get(
            `Common/GetRelatedObjectsCompactView/${compact_view_id}/${sub_module_code}/${record_id}/${sortColumn}/${sortDirection}/${pageNo}/${pageSize}/${companyId}`
        );
    }

    async getEmailList(
        SortDir,
        SortColumn,
        PageNo,
        PageSize,
        UserId,
        CompanyID,
        objectRefId,
        submodulename,
        objectname
    ) {
        //string SortDir, string SortColumn, string PageNo,string PageSize,string UserId,string CompanyID,string objectRefId, string submodulename string objectname
        return await api.get(
            `Common/GetSentEmailList/${SortDir}/${SortColumn}/${PageNo}/${PageSize}/${UserId}/${CompanyID}/${objectRefId}/${submodulename}/${objectname}`
        );
    }

    async checkStateIdAgainstStateName(object) {
        return await api.post(`Common/CheckStateIdAgainstStateName`, object);
        //return await api.get(`Common/CheckDuplicateCrm/${Id}/${PrimaryId}/${name}/${subModule}/${type}/${companyId}/${userId}`);
    }

    // ShowError() {
    //     this.toaster.error("Something went wrong. Please contact administrator.");
    //   }

    TryJsonParse(json) {
        try {
            let _json = JSON.parse(json);
            return _json;
        } catch {
            return json;
        }
    }

    GetOperatorExpression(operatorId, operatorList) {
        let expression = operatorList.filter(
            (item) => parseInt(item.value) == operatorId
        )[0].expression;

        switch (expression) {
            case "=":
                return "==";
            case "<>":
                return "!=";
            default:
                return expression;
        }
    }

    async GetopportunityDetailsByid(oppid) {
        return await api.get(`Common/GetopportunityDetailsByid/${oppid}`);
    }

    async GetCustomFormFieldList(userId, companyId, moduleName, formmasterid) {
        return await api.get(
            `WebMerge/GetFormFields/${userId}/${companyId}/${moduleName}/${formmasterid}`
        );
    }

    async getConfigurationTypeFileExtensions(configurationType, companyId) {
        return await api.get(
            `Common/GetConfigurationTypeFileExtensions/${configurationType}/${companyId}`
        );
    }

    async GetMasterItemsNotAuthLoanProduct(
        masterKey,
        masterNameText,
        userId,
        companyId
    ) {
        return await api.get(
            `Common/GetMasterItemList/${masterKey}/${masterNameText}/${userId}/${companyId}`
        );
    }

    async getCountryListNotAuth() {
        return await api.get(`Common/GetCountryListNotAuth`);
    }

    async getStatesList_V1(code) {
        return await api.get(`Common/GetStatesList_V1/${code}`);
    }



    //========================================== Time Zone Filter ==================================================//

    getUserSelectedZone() {
        debugger;
        let info = JSON.parse(localStorage.getItem("userinfo"));
        let zone = info.data.timeZone;
        return zone;
    }

    getUserUTCToSelectedZoneTime(date) {
        let _timezone = getUserSelectedZone();
        let time = moment.utc(date).tz(_timezone).format("hh:mm A");
        return time;
    }
    getUTCToSelectedZoneTime(date) {
        let time = moment.utc(date).format("hh:mm A");
        return time;
    }

    getUserSelectedZoneToUTC(date) {
        let timezone = getUserSelectedZone();
        let _date = moment(date).format("YYYY-MM-DDTHH:mm:ss");
        let utcdate = moment
            .tz(_date, timezone)
            .utc()
            .format("YYYY-MM-DD hh:mm:ss a");
        return utcdate;
    }

    getUserSelectedZoneToUTCAbsence(date, timezoneValue) {
        let timezone = timezoneValue;
        let _date = moment(date).format("YYYY-MM-DDTHH:mm:ss");
        let utcdate = moment
            .tz(_date, timezone)
            .utc()
            .format("YYYY-MM-DD hh:mm:ss a");
        return utcdate;
    }

    getUserSelectedZoneToUTCghantView(date, timezone) {
        //let timezone = this.getUserSelectedZone() as string;
        let _date = moment(date).format("YYYY-MM-DDTHH:mm:ss");
        let utcdate = moment
            .tz(_date, timezone)
            .utc()
            .format("YYYY-MM-DD hh:mm:ss a");
        return utcdate;
    }

    getUTCtoUserSelectedZone(date, timezone) {
        var result = moment.utc(date).tz(timezone).format("MM-DD-YYYY hh:mm A");
        result = dateTimeFormatChanger(this.locale, result);
        return result;
    }

    getUserSelectedZoneToUTCDate(date) {
        let timezone = getUserSelectedZone();
        let _date = moment(date).format("YYYY-MM-DDTHH:mm:ss");
        let utcdate = moment.tz(_date, timezone).utc().format("YYYY-MM-DD ");
        //_result = moment.utc(_date).tz(_timezone).format('MM-DD-YYYY');
        return utcdate;
    }

    ConvertUserSelectedTimeZoneToUTC(date) {
        let timezone = getUserSelectedZone();
        let _date = moment(date).format("YYYY-MM-DDTHH:mm:ss");
        let utcdate = moment
            .tz(_date, timezone)
            .utc()
            .format("YYYY-MM-DD HH:mm:ss");
        return utcdate;
    }
    ConvertUserSelectedTimeZoneToUTCForAppointment(date) {
        debugger;
        let timezone = this.getUserSelectedZone();
        let _date = moment(date).format("YYYY-MM-DDTHH:mm:ss");
        let utcdate = moment
            .tz(_date, timezone)
            .utc()
            .format("YYYY/MM/DD HH:mm:ss");
        return utcdate;
    }
    ConvertUserSelectedDateZoneToUTC(date) {
        let timezone = getUserSelectedZone();
        let _date = moment(date).format("YYYY-MM-DDTHH:mm:ss");
        let utcdate = moment.tz(_date, timezone).utc().format("YYYY-MM-DD");
        return utcdate;
    }
    ConvertUserSelectedDate(date) {
        let timezone = getUserSelectedZone();
        let _date = moment(date).format("YYYY-MM-DDTHH:mm:ss");
        return _date;
    }

    reduceOneDayOneSec(date) {
        let enddate = moment(date)
            .add(1, "days")
            .subtract(1, "seconds")
            .format("YYYY-MM-DDTHH:mm:ss");
        return enddate;
    }

    getTimeFormat() {
        let info = JSON.parse(localStorage.getItem("userinfo"));
        return info["timeFormat"];
    }
    async GetFileListForRelatedTab(
        serviceId,
        sortColumn,
        sortDir,
        pageNumber,
        pageSize,
        companyId,
        userId,
        categoryId,
        moduleCode,
        subModuleCode
    ) {
        return await api.get(
            `Common/GetFileListForRelatedTab/${serviceId}/${sortColumn}/${sortDir}/${pageNumber}/${pageSize}/${companyId}/${userId}/${categoryId}/${moduleCode}/${subModuleCode}`
        );
    }
    async GetDocumentMappingList(
        proposalId,
        companyId,
        userId,
        moduleCode,
        subModuleCode
    ) {
        return await api.get(
            `Common/GetDocumentMappingList/${proposalId}/${companyId}/${userId}/${moduleCode}/${subModuleCode}`
        );
    }
    async getNotesListCardView(
        objectRefId,
        moduleCode,
        subModuleCode,
        sortColumn,
        sortDir,
        pageNumber,
        pageSize,
        companyId,
        userId
    ) {
        return await api.get(
            `Common/GetNotesListCardView/${objectRefId}/${moduleCode}/${subModuleCode}/${sortColumn}/${sortDir}/${pageNumber}/${pageSize}/${companyId}/${userId}`
        );
    }
    async addEditNote(dataModel) {
        return await api.post(`Common/AddEditNote`, dataModel);
    }
    async addEditFollowUp(dataModel) {
        debugger;
        return await api.post(`Common/SaveFollowUp`, dataModel);
    }
    async SaveNoteFile(formData) {
        return await api.post(`Common/SaveNoteFile`, formData, {
            "Content-Type": "multipart/form-data",
        });
    }
    async getNoteReply(noteId, companyId, userId) {
        return await api.get(
            `Common/GetNoteReply/${noteId}/${companyId}/${userId}`
        );
    }
    async SaveFileNote(formData) {
        return await api.post(`Common/SaveFileNote`, formData, {
            "Content-Type": "multipart/form-data",
        });
    }

    async GetFollowUpForRelatedTab(
        SortDir,
        SortColumn,
        PageNo,
        PageSize,
        UserId,
        CompanyID,
        objectRefId,
        submodulename,
        objectname
    ) {
        return await api.get(
            `Common/GetFollowUpList/${SortDir}/${SortColumn}/${PageNo}/${PageSize}/${UserId}/${CompanyID}/${objectRefId}/${submodulename}/${objectname}`
        );
    }

    async GetEcryptedId(id) {
        return await api.get(`Common/GetEcryptedId/${id}`);
    }

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }

    async SaveFile(formData) {
        debugger;
        return await api.post(`Common/SaveRelatedFiles`, formData, {
            "Content-Type": "multipart/form-data",
        });
    }

    async addOrUpdateFiles(formData) {
        debugger;
        return await api.post(`Common/addOrUpdateFiles`, formData, {
            "Content-Type": "multipart/form-data",
        });
    }

    async GetPath(url) {
        return await api.post(`Common/GetFile`, url, {
            responseType: "blob"
        });
    }

    async DeleteRecords(deleteId, tableName, userId) {
        debugger;
        return await api.get(
            `Common/DeleteRecords/${deleteId}/${tableName}/${userId}`
        );
    }

    async downloadFileNote(url) {
        return await api.post(`Common/DownloadFileNote`, url, {
            responseType: "blob",
        });
    }

    async isCheckListFoundForCategory(checkListId, id, companyId, userId) {
        return await api.get(
            `Checklist/isCheckListFoundForCategory/${checkListId}/${id}/${companyId}/${userId}`
        );
    }

    async isUserExistWithSameEmail(email, companyId) {
        return await api.get(
            `Common/isUserExistWithSameEmail/${email}/${companyId}`
        );
    }

    async GetCompanyName(companyId) {
        return await api.get(`Common/GetCompnayName/${companyId}`);
    }

    async roomStatusCallBack(data) {
        return await api.post(`Common/setRoomParticipantInfo`, data);
    }

    getUpToDecimalPoint(decimalPlace) {
        let regEx = '';
        if (decimalPlace == '4') {
            regEx = '[0-9]{1,4}';
        } else if (decimalPlace == '3') {
            regEx = '[0-9]{1,3}';
        } else {
            regEx = '[0-9]{1,2}';
        }
        return regEx;
    }

    uploadPDFANDIMGAEFileValidator($file) {
        const fileName = $file.target.files[0].name;
        const extensions = [".pdf", ".png", ".jpeg", ".jpg", ".heic"];
        let blnValid = false;
        var isUploadFileValid = false;
        for (var j = 0; j < extensions.length; j++) {
            var sCurExtension = extensions[j];
            if (fileName.substr(fileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                blnValid = true;
                break;
            }
        }
        if (!blnValid) {
            $file.target.value = '';
            isUploadFileValid = false
            return isUploadFileValid;
            //toastr.error(`Valid file format is ${extensions.join(', ')}`);
        } else {
            isUploadFileValid = true;
            return isUploadFileValid;
        }
    }


    //#region Date Formatter
    //   dateFormatChanger(locale, date) {
    //     if (locale === 'en') {
    //       if (date != null) {
    //         let userApp = this.agentInformation();
    //         if (userApp == 'firefox') {
    //           return date;
    //         }
    //         else {
    //           let dateBeforeFormat = new Date(date);
    //           let dateAfterFormat = Intl.DateTimeFormat('en-US').format(dateBeforeFormat);
    //           return dateAfterFormat;
    //         }
    //       }
    //       else {
    //         return "";
    //       }
    //     } else if (locale === 'fr') {
    //       if (date != null) {
    //         let userApp = this.agentInformation();
    //         if (userApp == 'firefox') {
    //           return date;
    //         }
    //         else {
    //           let dateBeforeFormat = new Date(date);
    //           let dateAfterFormat = Intl.DateTimeFormat('fr-FR').format(dateBeforeFormat);
    //           return dateAfterFormat;
    //         }
    //       }
    //       else {
    //         return "";
    //       }
    //     }
    //     else if (locale === 'de') {
    //       if (date != null) {
    //         let userApp = this.agentInformation();
    //         if (userApp == 'firefox') {
    //           return date;
    //         }
    //         else {
    //           let dateBeforeFormat = new Date(date);
    //           let dateAfterFormat = Intl.DateTimeFormat('de-DE').format(dateBeforeFormat);
    //           return dateAfterFormat;
    //         }
    //       }
    //       else {
    //         return "";
    //       }

    //#region Date Formatter
    //   dateFormatChanger(locale, date) {
    //     if (locale === 'en') {
    //       if (date != null) {
    //         let userApp = this.agentInformation();
    //         if (userApp == 'firefox') {
    //           return date;
    //         }
    //         else {
    //           let dateBeforeFormat = new Date(date);
    //           let dateAfterFormat = Intl.DateTimeFormat('en-US').format(dateBeforeFormat);
    //           return dateAfterFormat;
    //         }
    //       }
    //       else {
    //         return "";
    //       }
    //     } else if (locale === 'fr') {
    //       if (date != null) {
    //         let userApp = this.agentInformation();
    //         if (userApp == 'firefox') {
    //           return date;
    //         }
    //         else {
    //           let dateBeforeFormat = new Date(date);
    //           let dateAfterFormat = Intl.DateTimeFormat('fr-FR').format(dateBeforeFormat);
    //           return dateAfterFormat;
    //         }
    //       }
    //       else {
    //         return "";
    //       }
    //     }
    //     else if (locale === 'de') {
    //       if (date != null) {
    //         let userApp = this.agentInformation();
    //         if (userApp == 'firefox') {
    //           return date;
    //         }
    //         else {
    //           let dateBeforeFormat = new Date(date);
    //           let dateAfterFormat = Intl.DateTimeFormat('de-DE').format(dateBeforeFormat);
    //           return dateAfterFormat;
    //         }
    //       }
    //       else {
    //         return "";
    //       }

    //     }
    //     else if (locale === 'es') {
    //       if (date != null) {
    //         let userApp = this.agentInformation();
    //         if (userApp == 'firefox') {
    //           return date;
    //         }
    //         else {
    //           let dateBeforeFormat = new Date(date);
    //           let dateAfterFormat = Intl.DateTimeFormat('es-ES').format(dateBeforeFormat);
    //           return dateAfterFormat;
    //         }
    //       }
    //       else {
    //         return "";
    //       }

    //     }
    //     else if (locale === 'ur') {
    //       if (date != null) {
    //         let userApp = this.agentInformation();
    //         if (userApp == 'firefox') {
    //           return date;
    //         }
    //         else {
    //           let dateBeforeFormat = new Date(date);
    //           let dateAfterFormat = Intl.DateTimeFormat('ur-PK').format(dateBeforeFormat);
    //           return dateAfterFormat;
    //         }
    //       }
    //       else {
    //         return "";
    //       }

    //     }
    //     else if (locale === 'hi') {
    //       if (date != null) {
    //         let userApp = this.agentInformation();
    //         if (userApp == 'firefox') {
    //           return date;
    //         }
    //         else {
    //           let dateBeforeFormat = new Date(date);
    //           let dateAfterFormat = Intl.DateTimeFormat('hi-IN').format(dateBeforeFormat);
    //           return dateAfterFormat;
    //         }
    //       }
    //       else {
    //         return "";
    //       }

    //     }
    //     else {
    //       if (date != null) {
    //         let userApp = this.agentInformation();
    //         if (userApp == 'firefox') {
    //           return date;
    //         }
    //         else {
    //           let dateBeforeFormat = new Date(date);
    //           let dateAfterFormat = Intl.DateTimeFormat('en-US').format(dateBeforeFormat);
    //           return dateAfterFormat;
    //         }
    //       }
    //       else {
    //         return "";
    //       }
    //     }
    //   }
    //#endregion
}

export class ModuleList {
    moduleId;
    moduleCode;
    moduleName;
    moduleRoute;
    moduleUserType;
    roleName;
    roleID;
    roleDescription;
    roleModuleAddFlag;
    roleModuleUpdateFlag;
    roleModuleReadFlag;
    roleModuleDeleteFlag;
    roleModuleEmailFlag;
    roleModuleSMSFlag;
    roleModuleNotificationFlag;
}
  
export class CheckboxData {
    controlname;
    controlvalues;
    constructor() {
      this.controlname = '';
      this.controlvalues = '';
    }
}

export class JsonDataValue {
    Id;
    FormJsonData;
    moduleCode;
    subModuleCode;
    companyId;
    userId;
    constructor() {
      this.Id = '';
      this.FormJsonData = '';
      this.moduleCode = '';
      this.subModuleCode = '';
      this.companyId = '';
      this.userId = '';
    }
  }